import PropTypes from "prop-types";
import { Link } from "react-router-dom";
// material
import { alpha, styled } from "@mui/material/styles";
import {
    Card,
    CardActionArea,
    Grid,
    // Avatar,
    Typography,
    CardContent,
    Tooltip,
    Checkbox,
    IconButton,
    Box,
} from "@mui/material";
// utils
import { fDate } from "../../../utils/formatTime";
// import { fShortenNumber } from "../../../utils/formatNumber";
//
import SvgIconStyle from "../../SvgIconStyle";
import axios from "axios";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

// ----------------------------------------------------------------------

const CardMediaStyle = styled("div")({
    position: "relative",
    paddingTop: "calc(100% * 3 / 4)",
});

const TitleStyle = styled("div")({
    height: 44,
    overflow: "hidden",
    WebkitLineClamp: 2,
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
});

// const AvatarStyle = styled(Avatar)(({ theme }) => ({
//     zIndex: 9,
//     width: 32,
//     height: 32,
//     position: "absolute",
//     left: theme.spacing(3),
//     bottom: theme.spacing(-2),
// }));

// const InfoStyle = styled("div")(({ theme }) => ({
//     display: "flex",
//     flexWrap: "wrap",
//     justifyContent: "flex-end",
//     marginTop: theme.spacing(3),
//     color: theme.palette.text.disabled,
// }));

const CoverImgStyle = styled("img")({
    top: "1em",
    bottom: "1em",
    width: "100%",
    height: "100%",
    objectFit: "contain",
    position: "absolute",
});

// ----------------------------------------------------------------------

BlogPostCard.propTypes = {
    post: PropTypes.object.isRequired,
    sortableId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    index: PropTypes.number,
    route: PropTypes.string.isRequired,
    draggable: PropTypes.bool,
    activeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    activeDrag: PropTypes.bool,
    suppressNavigationClick: PropTypes.bool,
    onConsumeNavigationSuppression: PropTypes.func,
    onContextMenu: PropTypes.func,
};

export default function BlogPostCard({
    post,
    sortableId,
    index,
    route,
    selected,
    onSelect,
    draggable,
    activeId,
    activeDrag,
    suppressNavigationClick,
    onConsumeNavigationSuppression,
    onContextMenu,
}) {
    const { slug, title } = post.content;
    const createdAt = post.content.created;
    // const author = post.uid;
    const cover = post.thumbnail ? `${post.thumbnail.filePath}` : null;

    const handleCheckboxClick = (e) => {
        e.stopPropagation(); // Prevent the CardActionArea from being triggered
        onSelect(slug);
    };

    const latestPostLarge = false; //index === 0;
    const latestPost = index === 1 || index === 2;
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging,
    } = useSortable({
        id: sortableId ?? post.nav_id,
        disabled: !draggable,
    });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1,
        cursor: draggable ? "grab" : "default",
    };

    return (
        <Grid
            item
            xs={12}
            sm={latestPostLarge ? 12 : 6}
            md={latestPostLarge ? 6 : 3}
        >
            <Tooltip title={post.tooltip ? post.tooltip : ""} placement="top">
                <Box
                    sx={{ position: "relative" }}
                    onContextMenu={(event) =>
                        onContextMenu && onContextMenu(event, post)
                    }
                >
                    <Card
                        ref={setNodeRef}
                        style={style}
                        sx={{ position: "relative" }}
                        {...attributes}
                        {...listeners}
                    >
                    <IconButton
                        sx={{
                            position: "absolute",
                            top: 8,
                            right: 8,
                            zIndex: 2,
                            background: "rgba(255,255,255,0.7)",
                        }}
                        onClick={handleCheckboxClick}
                        onMouseDown={(event) => event.stopPropagation()}
                        onPointerDown={(event) => event.stopPropagation()}
                    >
                        <Checkbox
                            checked={selected}
                            tabIndex={-1}
                            disableRipple
                            inputProps={{ "aria-label": "select content" }}
                        />
                    </IconButton>
                    <CardActionArea
                        component={Link}
                        to={`${route}${slug}`}
                        onClick={(event) => {
                            const shouldSuppressClick = Boolean(
                                suppressNavigationClick
                            );
                            if (
                                shouldSuppressClick ||
                                isDragging ||
                                (draggable && activeId) ||
                                (draggable && activeDrag)
                            ) {
                                event.preventDefault();
                                event.stopPropagation();
                                if (
                                    shouldSuppressClick &&
                                    onConsumeNavigationSuppression
                                ) {
                                    onConsumeNavigationSuppression();
                                }
                            }
                        }}
                    >
                        <CardMediaStyle
                            sx={
                                {
                                    // ...((latestPostLarge || latestPost) && {
                                    //     pt: "calc(100% * 4 / 3)",
                                    //     "&:after": {
                                    //         top: 0,
                                    //         content: "''",
                                    //         width: "100%",
                                    //         height: "100%",
                                    //         position: "absolute",
                                    //         bgcolor: (theme) =>
                                    //             alpha(theme.palette.grey[900], 0.5),
                                    //     },
                                    // }),
                                    // ...(latestPostLarge && {
                                    //     pt: {
                                    //         xs: "calc(100% * 4 / 3)",
                                    //         sm: "calc(100% * 3 / 4.66)",
                                    //     },
                                    // }),
                                }
                            }
                        >
                            {/* <AvatarStyle
                        alt={author.name}
                        src={author.avatarUrl}
                        sx={{
                            ...((latestPostLarge || latestPost) && {
                                zIndex: 9,
                                top: 24,
                                left: 24,
                                width: 40,
                                height: 40,
                            }),
                        }}
                    /> */}

                            {cover && <CoverImgStyle alt={title} src={cover} />}
                        </CardMediaStyle>

                        <CardContent
                            sx={{
                                pt: 4,
                                // ...((latestPostLarge || latestPost) && {
                                //     bottom: 0,
                                //     width: "100%",
                                //     position: "absolute",
                                // }),
                            }}
                        >
                            <Typography
                                color="text.disabled"
                                gutterBottom
                                variant="caption"
                                sx={{
                                    display: "block",
                                    // ...((latestPostLarge || latestPost) && {
                                    //     color: "common.white",
                                    // }),
                                }}
                            >
                                {fDate(createdAt)}
                                {/* {createdAt} */}
                            </Typography>

                            <TitleStyle
                                color="inherit"
                                variant="subtitle2"
                                underline="hover"
                                sx={
                                    {
                                        // ...(latestPostLarge && {
                                        //     typography: "h5",
                                        //     height: 60,
                                        // }),
                                        // ...((latestPostLarge || latestPost) && {
                                        //     color: "common.white",
                                        // }),
                                    }
                                }
                            >
                                {title}
                            </TitleStyle>
                        </CardContent>
                    </CardActionArea>
                    </Card>
                </Box>
            </Tooltip>
        </Grid>
    );
}
